import React from 'react'
import useOffer from 'hooks/Offers/useOffer'
import MiniTileLoadingSkeleton from 'components/Pages/HotelSearchPage/OfferMiniTile/MiniTileLoadingSkeleton'
import HomesVillasMiniTile from 'components/Pages/HotelSearchPage/OfferMiniTile/HomesVillasMiniTile'

interface Props {
  offerId: string;
  filters: App.OfferListFilters;
  onClick?: () => void;
}

function HomesVillasMiniTileContainer({
  offerId,
  filters,
  onClick,
}: Props) {
  const [offer, fetchingOffer] = useOffer<App.VillaOffer>(offerId)

  return <>
    { fetchingOffer && <MiniTileLoadingSkeleton /> }
    { !!offer && <HomesVillasMiniTile offer={offer} filters={filters} onClick={onClick} />}
  </>
}

export default HomesVillasMiniTileContainer
